import type { ChipStatus } from "../../components/ui";
import { JobCardQueue, QUEUE_STATUS } from "./jobCardApi";

export const CHIP_STATUS: Record<string, ChipStatus> = {
  pending: "info",
  completed: "info",
  draft: "info",
  sent: "warning",
  accepted: "warning",
  needs_revision: "warning",
  approved: "success",
  finalised: "success",
  rejected: "error",
};

export const money = (n: number) => `$${n.toFixed(2)}`;

export const formatDate = (iso: string | null) =>
  iso
    ? new Date(iso).toLocaleDateString("en-GB", {
        day: "numeric",
        month: "short",
        year: "numeric",
      })
    : "No date";

// The shared Button applies its own colours only when no `sx` is passed, so
// tinted variants supply the full style themselves.
export const tone = (bg: string, fg: string) => ({
  borderRadius: 2,
  fontWeight: "bold",
  textTransform: "none",
  px: 3,
  backgroundColor: bg,
  color: fg,
  "&:hover": { backgroundColor: bg, filter: "brightness(0.96)" },
});

export const REJECT_TONE = { bg: "#F8E9E4", fg: "#A83C24" };
export const REVISION_TONE = { bg: "#F7EDD9", fg: "#8A5C0D" };

export const errorMessage = (e: unknown, fallback: string): string => {
  const message = (e as { response?: { data?: { message?: unknown } } })?.response?.data
    ?.message;
  if (typeof message === "string") return message;
  if (message && typeof message === "object") {
    return Object.values(message as Record<string, unknown>).flat().join(" ");
  }
  return fallback;
};

export const statusLabel = (queue: JobCardQueue, value: string): string =>
  QUEUE_STATUS[queue].find((o) => o.value === value)?.label ?? value;
